import { IonPage, useIonViewWillLeave } from '@ionic/react'
import React from 'react'
import PCRHeader from '../../../../components/pcrHeader/PCRHeader.component'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import HeaderNav from '../../../../components/headerNav/HeaderNav.component'
import VitalsPainQualityContent from '../content/VitalsPainQuality.content'
import { TabConstants } from '../../../../components/tabs/Tabs.constants'
import { useDispatch } from 'react-redux'
import { checkQuickActionsRedirect } from '../../store/vitals.actions'
import { setScrollTargetID } from '../../../../components/scrollToTopButton/store/scrollToTop.actions'

const VitalsPainQuality: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()

  const onBackClick = () => {
    history.back()
  }

  useIonViewWillLeave(() => {
    if (history.location.pathname !== TabConstants.VITALS_TAB) {
      dispatch(checkQuickActionsRedirect())
    } else {
      dispatch(setScrollTargetID('painQualityButton'))
    }
  })

  return (
    <IonPage id='VitalsPainQualityContent'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        title={t('vitals.painQuality.title')}
        isBackButton={true}
      />
      <VitalsPainQualityContent />
    </IonPage>
  )
}

export default VitalsPainQuality
